import { ChangeDetectionStrategy, Component, TemplateRef, ViewChild, inject } from '@angular/core';
import { IrisProjectSelectEngine } from '../project-select.engine';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StrakitToggleComponent } from '@ngx-strakit/cdk/controls';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'iris-project-select-dropdown-header',
  templateUrl: './dropdown-header.component.html',
  styles: `:host { display: none; }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    StrakitToggleComponent,
    FormsModule,
  ],
  standalone: true,
})
export class IrisProjectSelectDropdownHeaderComponent {
  readonly engine = inject(IrisProjectSelectEngine);

  @ViewChild('template', { static: true }) template: TemplateRef<unknown>;
}
